import { ProdutoApi } from '../api/produto.api';
import { VendaApi } from '../api/venda.api';
import { UpSellApi } from '../api/up-sell.api';

export class Api {
  constructor() {
    this.Produto = new ProdutoApi();
    this.Venda = new VendaApi();
    this.UpSell = new UpSellApi();
  }
  public Produto: ProdutoApi;
  public Venda: VendaApi;
  public UpSell: UpSellApi;
}

export const useApi = (): Api => {
  return new Api();
};
